.artifact {
    width: 1.5em;
    height: 1.5em;
    border-radius: 50%;
    display: inline-block;
    text-align: center;
    color: white;
    line-height: calc(1.5em - 6px);
    margin: 0.1em;
    border: 3px solid transparent;
}

.artifact.artifact-green {
    background: darkgreen;
}

.artifact.artifact-purple {
    background: purple;
}

.artifact.artifact-none {
    background: white;
    border: 1px solid black;
}

.randomizer-icon {
    width: 22px;
    display: inline-block;
}

.randomizer-icon svg, .classifier svg {
    height: 20px;
    width: 20px;
}

.classifiedMatches {
    background: orange;
}